<template>
  <component :is="layout"></component>
</template>

<script>
import NormalLayout from './NormalLayout'
import MainContentLayout from './MainContentLayout'
import EmptyLayout from './EmptyLayout'
import MapLayout from './MapLayout'

const defaultLayout = 'empty'

export default {
  name: 'AppMember',
  components: {
    NormalLayout,
    EmptyLayout,
    MainContentLayout,
    MapLayout,
  },
  computed: {
    layout() {
      return `${this.$route.meta.layout || defaultLayout}-layout`
    },
    titlePage() {
      return this.$route.meta && this.$route.meta.title
        ? this.$t(this.$route.meta.title)
        : this.$t('common.title_pages.default')
    },
  },
  watch: {
    $route: {
      handler: function (newVal, oldValue) {
        document.title = this.titlePage
        const listRoute = ['center.berth.schedule', 'transporter.work-schedule']
        if (oldValue && listRoute.includes(oldValue.name)) {
          // Refreshes page
          this.$router.go()
        }
      },
      immediate: true,
      deep: true,
    },
  },
}
</script>

<style scoped>

</style>
